import { render } from "./AppSideMenu.vue?vue&type=template&id=0a7f3f2a&ts=true"
import script from "./AppSideMenu.vue?vue&type=script&lang=ts"
export * from "./AppSideMenu.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/dashboard_viomba_com/25/public/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__